import React from 'react';
import _ from 'lodash';

_.mixin({
	nl2br : function(str, is_xhtml){
	    if(this.is_empty(str))
	        return str;

	    return str.split(/(\r\n|\r|\n)/g).map(function(line, index) {
            if(line.match(/(\r\n|\r|\n)/g))
                return React.createElement('br', { key: index });
            
            return line;
        });
	},
	cloneData(object) {
	    if(!object)
	        return object;

	    return JSON.parse(JSON.stringify(object));
	},
	is_empty(val) {
	    if(val === null || typeof val == 'undefined')
	        return true;

        if(typeof val == 'string')
            return val.trim().length == 0;

        if(typeof val == 'function' || typeof val == 'number' || val instanceof File || typeof val == 'boolean')
            return false;
        
        if(typeof val == 'object')
            return _.isEmpty(val);
        
        return true;
	},
	if_empty(val, default_value) {
	    if(_.is_empty(val))
	        return default_value;
        
        return val;
	},
	function_param_encode: function(object) {
	    return encodeURIComponent(JSON.stringify(object));
	},
	function_param_decode: function(string) {
	    return JSON.parse(decodeURIComponent(string));
	},
	is_value_in_set: function(set, item, seperator) {
	    if(!seperator)
	        seperator = ',';
	        
	    return _.includes(seperator + set + seperator, seperator + item + seperator);
	},
	toggle_value_in_set: function(set, item, seperator) {
	    if(!seperator)
	        seperator = ',';
        
        if(set == null)
            set = '';
        else
            set = set + '';

        if(_.is_value_in_set(set, item, seperator))
            return (seperator + set + seperator).replace(seperator + item + seperator, seperator).slice(seperator.length, seperator.length*-1);
        
        return (set && set.trim() != '' ? set + seperator : '') + item;
	},
	change_hash: function(hash) {
	    history.replaceState(null, null, '#' + hash);
	},
	get_url_hash: function(url) {
    	if(url === undefined)
    		return '';
    
    	if(url.indexOf('#') < 0)
    		return url;
    
    	if(url.substring(0,1) == '#')
    		return url.substring(1);
    
    	url = url.split("#");
    
    	return url[1];
    },
    get_url_params: function(params) {
    	var params_array = {};
    
    	if(params === '')
    		return params_array;
    
    	params = _.get_url_hash(params).split('?').pop().split('&');
    
    	for(var key in params) {
    		var key_value = params[key].split('=');
    		
    		// Checken of er wel een value in zit. Anders als de url geen params heeft kan er een / als key opgegeven worden met undefined als value.
    		if(key_value.length > 1)
    		    params_array[key_value[0]] = decodeURIComponent(key_value[1]);
    	}
    	
    	return params_array;
    },
    set_url_params: function(params, new_params, exclude_null) {
        let url = [];
        params  = {...this.get_url_params(params), ...new_params};
        
        for(let field in params)
            if(!exclude_null || params[field] != null)
                url.push(field + '=' + encodeURIComponent(params[field]));
        
        return '?' + url.join('&');
    },
    update_url_hash_params: function(new_params)
    {
        let prefix          = (window.location.hash.includes('?') ? window.location.hash.split('?')[0] : window.location.hash).replace('#', '');
        let url_params      = this.set_url_params(window.location.hash, {...new_params}, true);
        
        _.change_hash(prefix + url_params);
    },
    params_to_hash: function(params, push) {
        if(!push)
            push = false;
        
        var hash = '';
        
        for(var i in params)
            if(params[i] && params[i] != '')
                hash += (hash == '' ? '' : '&') + i + '=' + params[i];
    
        if(!push)
            return hash;
        
        window.history.pushState('', '', location.protocol + '//' + location.host + location.pathname + '#' + hash);
    },
	get_file_extension: function(filename) {
	    return filename.substring(filename.lastIndexOf('.') + 1).toLowerCase();
	},
	get_file_name: function(filename) {
	    return filename.substring(0, filename.lastIndexOf('.')).toLowerCase();
	},
	format_input: function(value, settings) {
	    settings = {string_to_lower: false, format_numbers: true, nullify_empty_values: false, ...settings};
	    
	    if(_.isPlainObject(value) || _.isArray(value))
	    {
	        for(let i in value)
	            value[i] = this.format_input(value[i], settings);

            return value;
	    }

	    if(_.isString(value) && settings.string_to_lower)
            value = value.toLowerCase();
        
        let formatted_value = value;
        
        // Wordt bijv. in ReactModel en DataModel op false gezet omdat je daar via isEqual de precieze data wilt vergelijken
        if(settings.format_numbers)
        {
            formatted_value = (formatted_value + '').replace(/(0|\.)+$/, '');
            
            // Als de waarde leeg is was de value bijv. 0.00. De bovenstaande replace zou dan alles weghalen, dus kunnen we hem gewoon als 0 teruggeven.
            if(!_.isEmpty(value) && (value[0] + '') == '0' && _.is_empty(formatted_value))
                return 0;
        }
        
        if(!_.isEmpty(value) && !isNaN(value) && !_.isArray(value) && !_.isDate(value) && !_.isBoolean(value) && value !== null && (value % 1) === 0 && (value[0] !== '0' || value.length == 1) && (value == 0 || /^-?\d+$/.test(formatted_value)))
            value = parseInt(value);
        else if(!_.isEmpty(value) && Number(value).toString() === formatted_value && (value % 1) !== 0)
            value = parseFloat(value);
        else if(settings.nullify_empty_values && _.is_empty(value) && !_.isBoolean(value) && !_.isPlainObject(value) && !_.isArray(value))
            value = null;

        return value;
	},
	print_time_marker: function(text) {
	    if(!this.time_marker)
	        this.time_marker = new Date();

        this.time_marker = new Date();
	},
	time_period_is_between_time_period: function(f_start_time, f_end_time, t_start_time, t_end_time)
    {
        function between_time(f, t, i)
        {
            return (f <= i && i !== f) && (i <= t && i !== t)
        }
    
        return between_time(f_start_time, f_end_time, t_start_time) || between_time(f_start_time, f_end_time, t_end_time) || between_time(t_start_time, t_end_time, f_start_time) || between_time(t_start_time, t_end_time, f_end_time) || (t_start_time == f_start_time && f_end_time == t_end_time);
    },
    get_distance_between_coordinates: function(from_lat, from_lon, to_lat, to_lon) 
    {
        if(!from_lat || !from_lon || !to_lat || !to_lon)
            return 9999;
        
        // if($.coordinate_cache === undefined)
        //     $.coordinate_cache = {};
            
        let key = from_lat + ',' + from_lon + '-' + to_lat + ',' + to_lon;
            
        // if($.coordinate_cache[key] !== undefined)
        //     return $.coordinate_cache[key];
        
        let rad_from_lat    = Math.PI * from_lat/180;
        let rad_to_lat      = Math.PI * to_lat/180;
        let theta           = from_lon-to_lon;
        let radtheta        = Math.PI * theta/180;
        let dist            = Math.sin(rad_from_lat) * Math.sin(rad_to_lat) + Math.cos(rad_from_lat) * Math.cos(rad_to_lat) * Math.cos(radtheta);
        
        if(dist > 1)
            dist = 1;
        
        dist = ((Math.acos(dist) * 180/Math.PI) * 60 * 1.1515) * 1.609344;
        
        // $.coordinate_cache[key] = dist;
        
        return dist;
    },
    json_to_form_data: function(data = {}, form = null, namespace = '') {
        let model       = _.cloneDeep(data);
        let formData    = form || new FormData();

        for (let propertyName in model)
        {
            if (!model.hasOwnProperty(propertyName))
                continue;
                
            let formKey = namespace ? `${namespace}[${propertyName}]` : propertyName;
            
            if (model[propertyName] instanceof Date)
                formData.append(formKey, model[propertyName].toISOString());
            else if (model[propertyName] instanceof File)
                formData.append(formKey, model[propertyName]);
            else if ((model[propertyName] instanceof Array || typeof model[propertyName] === 'object') && model[propertyName] !== null)
            {
                // Sommige plugins geven fileName terug ipv name. Dus die zetten we hier dan om
                if(!model[propertyName].name && model[propertyName].fileName)
                    model[propertyName].name = model[propertyName].fileName;
                
                if(model[propertyName].uri && model[propertyName].name && model[propertyName].type)
                    formData.append(formKey, model[propertyName]);
                else if(_.is_empty(model[propertyName]))
                    formData.append(formKey, ''); // Anders wordt bijv. het filter niet meegestuurd als je hem reset.
                else
                    this.json_to_form_data(model[propertyName], formData, formKey);
            }
            else
                formData.append(formKey, (model[propertyName] !== null && model[propertyName] !== undefined ? model[propertyName].toString() : ''));
        }

        return formData;
    },
    time_to_minutes: function(time) {
    	time = time.split(':');
    
    	return (parseInt(time[0])*60) + parseInt(time[1]);
    },
    minutes_to_time: function(minutes, multiple_days, allow_negatives) {
        if(typeof multiple_days == 'undefined')
            multiple_days = false;
        
        if(typeof allow_negatives == 'undefined')
            allow_negatives = true;
        
    	var hours       = 0;
    	var negative 	= false;
    
    	if(minutes > 0 || allow_negatives)
    	{
    		if(minutes < 0)
    		{
    			negative 	= true;
    			minutes 	*= -1;
    		}
    
    		hours		= Math.floor(minutes/60);
    		minutes 	= (minutes%60);
    
    		if(!multiple_days)
    			hours = hours%24;
    	}
    	else
    		minutes = 0;
    
    	return (negative ? '-' : '') + (hours < 10 ? '0' : '') + hours + ':' + (minutes < 10 ? '0' : '') + minutes;
    },
    minutes_to_time_text: function(start_minutes, always_show_minutes, show_hours_when_available)
    {
        let minus       = (start_minutes < 0);
        start_minutes   = Math.abs(start_minutes);
        let hours       = Math.floor(start_minutes / 60);
        let minutes     = start_minutes % 60;
        let result      = [];
        
        if(!show_hours_when_available || hours > 0)
            result.push((minus ? '-' : '') + hours + ' u');
        
        if(always_show_minutes || minutes > 0)
            result.push(minutes + ' m');

        return result.join(' ');
    },
    add_minutes_to_time: function(starttime, minutes, multiple_days) {
    	starttime	= starttime.split(':');
    	starttime	= (parseInt(starttime[0])*60) + parseInt(starttime[1]);
    	let endtime		= starttime + parseInt(minutes);
    
    	return this.minutes_to_time(endtime, multiple_days);
    },
    get_time_difference: function(start_time, end_time, in_minutes) {
        start_time  = _.time_to_minutes(start_time);
        end_time    = _.time_to_minutes(end_time);
        
        if(end_time < start_time)
            end_time += 24 * 60;
        
        return in_minutes === true ? end_time - start_time : _.minutes_to_time(end_time - start_time);
    },
    get_time_format: function(time, include_seconds) {
        time = time.split(' ');
    
    	if(time.length > 1)
    		time = time[time.length - 1];
    	else
    		time = time[0];
    		
    	time = time.split(':');
    
    	return time[0] + ':' + time[1] + (include_seconds ? ':' + _.if_empty(time[2], '00') : '');
    },
    get_date_format: function(date, reverse) {
        if(!reverse)
            reverse = false;
        
    	date = date.toString().split(' ');
    	date = date[0];
    
    	if ((date[2] == '-' && !reverse) || (reverse && date[4] == '-'))
    		return date;
    
    	date = date.split('-');
    
    	if(date.length != 3)
    		return '';
    
    	return date[2] + '-' + date[1] + '-' + date[0];
    },
    get_datetime_format: function(datetime, reverse) {
        if(!reverse)
            reverse = false;
    
    	datetime = datetime.split(' ');
    
    	return this.get_date_format(datetime[0], reverse) + ' ' + this.get_time_format(datetime[1]);
    },
    is_crossing_period: function(check_start_date, check_end_date, start_date, end_date)
    {
        check_start_date    = this.get_date_format(check_start_date, true);
        check_end_date      = this.get_date_format(check_end_date, true);
        start_date          = this.get_date_format(start_date, true);
        end_date            = this.get_date_format(end_date || '9999-01-01', true);
        let start_overlap   = (check_start_date >= start_date && check_start_date <= end_date);
        let end_overlap     = (check_end_date >= start_date && check_end_date <= end_date);
        let outside_overlap = (check_start_date <= start_date && check_end_date >= end_date);

        return start_overlap || end_overlap || outside_overlap;
    },
    is_crossing_datetime_period: function(check_start_datetime, check_end_datetime, start_datetime, end_datetime)
    {
        check_start_datetime    = this.get_datetime_format(check_start_datetime, true);
        check_end_datetime      = this.get_datetime_format(check_end_datetime, true);
        start_datetime          = this.get_datetime_format(start_datetime, true);
        end_datetime            = this.get_datetime_format(end_datetime || '9999-01-01 07:00:00', true);
        let start_overlap       = (check_start_datetime >= start_datetime && check_start_datetime <= end_datetime);
        let end_overlap         = (check_end_datetime >= start_datetime && check_end_datetime <= end_datetime);
        let outside_overlap     = (check_start_datetime <= start_datetime && check_end_datetime >= end_datetime);

        return start_overlap || end_overlap || outside_overlap;
    },
    is_crossing_year_week_period: function(check_start_year_week, check_end_year_week, start_year_week, end_year_week)
    {
        end_year_week       = end_year_week || check_end_year_week;
        let start_overlap   = (check_start_year_week >= start_year_week && check_start_year_week <= end_year_week);
        let end_overlap     = (check_end_year_week >= start_year_week && check_end_year_week <= end_year_week);
        let outside_overlap = (check_start_year_week <= start_year_week && check_end_year_week >= end_year_week);
        
        return start_overlap || end_overlap || outside_overlap;
    },
    custom_fetch(url, options)
    {
        options         = {...{method: 'POST', withCredentials: true, headers: {}}, ...options};
        options.headers = {...{'Content-Type': 'multipart/form-data'}, ...options.headers};
        
        return new Promise((resolve, reject) => {
            let xhr = new XMLHttpRequest();
            
            xhr.open(options.method, url, true);
            
            xhr.withCredentials = options.withCredentials;
            
            for(let header_property in options.headers)
                xhr.setRequestHeader(header_property, options.headers[header_property]);

            xhr.onload = e => {
                let body = 'response' in xhr ? xhr.response : xhr.responseText
                
                resolve(body);
            }
            xhr.onerror = reject;
            
            if(xhr.upload && options.onProgress)
                xhr.upload.onprogress = options.onProgress;
            
            xhr.send(options.body);
        });
    },
    filterSupportedProps(props, supportedProps)
    {
        let safeProps = {};
        
        for (let prop in props)
        {
            if (props.hasOwnProperty(prop) && (supportedProps[prop] || prop.indexOf('aria-') === 0 || prop.indexOf('data-') === 0))
                safeProps[prop] = (typeof props[prop] == 'int' ? props[prop] + '' : props[prop]);
        }
    
        return safeProps;
    },
    filterExcludedProps(props, excludedProps)
    {
        let safeProps = {};
        
        for (let prop in props)
        {
            if(excludedProps.includes(prop))
                continue;
                
            safeProps[prop] = (typeof props[prop] == 'int' ? props[prop] + '' : props[prop]);
        }
    
        return safeProps;
    },
    validEmail(email) {
        return /[A-Za-z0-9_\-\.]+([\.]{1}[A-Za-z0-9_-]+)*@[A-Za-z0-9-]+([\.]{1}[A-Za-z0-9-]+)+/.test(email);
    },
    validInt(integer) {
        return (!_.is_empty(integer) && !isNaN(integer) && !_.isArray(integer) && !_.isDate(integer) && !_.isBoolean(integer) && (integer % 1) === 0 && ((integer + '').length == 1 || (integer + '')[0] !== '0') && /^-?\d+$/.test(integer));
    },
    getFullMonth(dateObject){
        return dateObject.getMonth() + 1;
    },
    getYearMonthDay(dateObject) {
        var day     = (dateObject.getDate().toString().length < 2 ? '0' : '') + dateObject.getDate();
        var month   = (this.getFullMonth(dateObject).toString().length < 2 ? '0' : '') + this.getFullMonth(dateObject); 
        var year    = dateObject.getFullYear();
        
        return year + '-' + month + '-' + day;
    },
    getDayText(dateObject, capital, short_notation)
    {
        var days = [
            'zondag',
            'maandag',
            'dinsdag',
            'woensdag',
            'donderdag',
            'vrijdag',
            'zaterdag'
        ];
        
        var value = '';
        
        if(short_notation === true)
            value = days[dateObject.getDay()].substr(0, 2);
        else
            value = days[dateObject.getDay()];
        
        if(capital === true)
            value = value.charAt(0).toUpperCase() + value.slice(1);
        
        return value;
    },
    getMonthText(dateObject, capital, short_notation)
    {
        var months = [
            {title: 'januari', short_title: 'jan'},
            {title: 'februari', short_title: 'feb'},
            {title: 'maart', short_title: 'mrt'},
            {title: 'april', short_title: 'apr'},
            {title: 'mei', short_title: 'mei'},
            {title: 'juni', short_title: 'jun'},
            {title: 'juli', short_title: 'jul'},
            {title: 'augustus', short_title: 'aug'},
            {title: 'september', short_title: 'sep'},
            {title: 'oktober', short_title: 'okt'},
            {title: 'november', short_title: 'nov'},
            {title: 'december', short_title: 'dec'},
        ];
        
        var value = '';
        
        if(short_notation === true)
            value = months[dateObject.getMonth()].short_title;
        else
            value = months[dateObject.getMonth()].title;
        
        if(capital === true)
            value = value.charAt(0).toUpperCase() + value.slice(1);
        
        return value;
    },
    remove_item(array, value)
    {
        let index = array.indexOf(value);
        
        if(index >= 0)
            array.splice(index, 1);
    },
    money_format(price, settings)
    {
        settings = {...{ style: 'currency', currency: 'EUR', minimumFractionDigits: 2}, ...settings};
        
        if(price && (price.toString().substr(-3, 1) == ',' || price.toString().substr(-2, 1) == ','))
            price = price.toString().replace('.', '').replace(',', '.');
        
        if(typeof settings.round != 'undefined')
            price = _.round(price, settings.round);
        
        if(typeof Intl != 'undefined' && Intl.NumberFormat)
            return new Intl.NumberFormat('nl-NL', settings).format(price);
        
        if(typeof price != 'number')
            price = parseFloat(price)
        
        price = price.toFixed(settings.minimumFractionDigits);
        
        if(settings.minimumFractionDigits > 0)
            price = price.replace('.', ',');
        
        return price.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    },
    number_format(number, settings)
    {
        return _.money_format(number, {...{minimumFractionDigits: 0, style: 'decimal'}, ...settings});
    },
    is_newer_version (old_version, new_version) {
        let old_parts = old_version.split('.');
        let new_parts = new_version.split('.');
        
        for (var i = 0; i < new_parts.length; i++)
        {
            let a = ~~new_parts[i]; // parse int
            let b = ~~old_parts[i]; // parse int
            
            if (a > b)
                return true;
            
            if (a < b)
                return false;
        }

        return false;
    },
    has_object_chain(object, settings) {
        if(!settings.chain || !object)
            return false;
        
        let cloned_object = object;
        
        for(let i in settings.chain)
        {
            if(!cloned_object[settings.chain[i]])
                return false;
            
            cloned_object = cloned_object[settings.chain[i]];
        }
        
        if(!settings.allow_empty_value)
            return !_.is_empty(cloned_object);
        
        return true;
    },
    set_object_chain(object, settings) {
        if(!settings.chain)
            return object;

        let object_for_key = object;

        for(let i in settings.chain)
        {
            let key = settings.chain[i];

            if(!object_for_key[key])
            {
                if(settings.chain[parseInt(i) + 1] !== undefined || settings.value === undefined)
                    object_for_key[key] = {};
                else if(settings.value_as_array)
                {
                    if(!object_for_key[key])
                        object_for_key[key] = [];
                    
                    object_for_key[key].push(settings.value);
                }
                else
                    object_for_key[key] = settings.value;
            }
            
            object_for_key = object_for_key[key];
        }
    },
    round(number, decimals) {
        if(!decimals)
            decimals = 0;

        if(_.includes(number.toString(), 'e-') && parseInt(number.toString().split('e-')[1]) > decimals)
            return 0;

        return +(Math.round(number + 'e+' + decimals)  + 'e-' + decimals);
    },
    is_allowed_action(settings) {
        settings = {...{actions: null, action: null, group: null, user: null, items: null, user_policies: null}, ...settings};
        
        if(_.is_empty(settings.action))
    		return false;
    
    	if(_.is_empty(settings.actions))
    		return true;

    	// Als er geen rechten ingesteld staan voor deze actie is alles toegestaan
    	if(!new RegExp('.*?(^|;)' + settings.action + ':').test(settings.actions))
    		return true;
    
    	if(_.is_empty(settings.items))
    		return false;
    
    // 	if(!_.is_empty(settings.user_policies) && !_.is_empty(settings.group) && !_.is_empty(settings.user))
    // 	{
    // 		let matches = settings.user_policies.match('/(u' + settings.user + '|g' + settings.group + '):([gpu0-9|]*?);/');
    // 
    // 		if(!_.is_empty(matches[2]))
    // 			settings.items .= '|' . implode('|', $matches[2]);
    // 	}

    	return new RegExp('(^|;)' + settings.action + ':([gpu0-9,]*?)(' + settings.items + ')(,|;)').test(settings.actions);
    },
    handle_filter_fields(model) {
        let valid = true;
        
        for(var key in this.filter_field)
        {
            if(this.type == 'models' && this.filter_field[key].type == 'has_data')
            {
                valid = (model.has_data() == this.filter_field[key].value);
            }
            else if(this.filter_field[key].type == 'function' || typeof this.filter_field[key].value == 'function')
            {
                if(!this.filter_field[key].value(model))
                    valid = false;
            }
            else
            {
                // Als hij vanuit de models komt hebben we een object, dus moeten we de functie aanroepen om de data terug te krijgen.
                let model_value = (this.type == 'models' ? model.get_field_data(key) : model[key]);
                model_value     = _.format_input((_.isPlainObject(model_value) || _.isArray(model_value) ? _.cloneDeep(model_value) : model_value), {string_to_lower: true});

                // Zodat hij niet in een loop een format doet terwijl hij die eigenlijk maar 1 keer hoeft te doen.
                if(!this.filter_field[key].input_formatted)
                {
                    this.filter_field[key].value            = _.format_input(this.filter_field[key].value, {string_to_lower: true});
                    this.filter_field[key].input_formatted  = true;
                }

                if(this.filter_field[key].type == 'includes')
                {
                    if(_.isPlainObject(this.filter_field[key].value) || _.isArray(this.filter_field[key].value))
                    {
                        let found = false;
                        
                        for(let i in this.filter_field[key].value)
                        {
                            if(_.includes(model_value, this.filter_field[key].value[i]))
                                found = true;
                        }
                        
                        if(!found)
                            valid = false;
                    }
                    else if(!_.includes(model_value, this.filter_field[key].value))
                        valid = false;
                }
                else if(this.filter_field[key].type == 'includes_desc')
                {
                    if(_.isPlainObject(model_value) || _.isArray(model_value))
                    {
                        let found = false;
                        
                        for(let i in model_value)
                        {
                            if(_.includes(this.filter_field[key].value, model_value[i]))
                                found = true;
                        }
                        
                        if(!found)
                            valid = false;
                    }
                    else if(!_.includes(this.filter_field[key].value, model_value))
                        valid = false;
                }
                else if(this.filter_field[key].type == 'excludes')
                {
                    if(model_value == this.filter_field[key].value)
                        valid = false;
                }
                else if(this.filter_field[key].type == 'excludes_desc')
                {
                    if(_.includes(this.filter_field[key].value, model_value))
                        valid = false;
                }
                else if(this.filter_field[key].type == 'is_value_in_set')
                {
                    if(!_.is_value_in_set(model_value, this.filter_field[key].value))
                        valid = false;
                }
                else if(this.filter_field[key].type == 'is_value_in_set_desc')
                {
                    if(!_.is_value_in_set(this.filter_field[key].value, model_value))
                        valid = false;
                }
                else
                {
                    let value           = model_value;
                    let settings_value  = this.filter_field[key].value;
                    
                    // Als het een datum is moeten we de timestamps met elkaar vergelijken. Date objects vergelijken werkt niet.
                    if(_.isDate(model_value) && _.isDate(this.filter_field[key].value))
                    {
                        value           = model_value.getTime();
                        settings_value  = this.filter_field[key].value.getTime();
                    }
    
                    if(this.filter_field[key].type == '>')
                    {
                        if(value <= settings_value)
                            valid = false;
                    }
                    else if(this.filter_field[key].type == '>=')
                    {
                        if(value < settings_value)
                            valid = false;
                    }
                    else if(this.filter_field[key].type == '<')
                    {
                        if(value >= settings_value)
                            valid = false;
                    }
                    else if(this.filter_field[key].type == '<=')
                    {
                        if(value > settings_value)
                            valid = false;
                    }
                    else if(value != settings_value)
                        valid = false;
                }
            }
            
            if(!valid)
                return valid;
        }

        return valid
    },
    plural(settings) {
        settings = {...{singular: '', plural: ''}, ...settings};

        if(settings.amount == 1)
            return settings.singular;
        
        return settings.plural;
    },
    join_group(array, separator, last_item_seperator) {
        if(typeof last_item_seperator == 'undefined')
            return array.join(separator);
        
        let a           = _.cloneDeep(array);
        let last_item   = a.pop();
        
        if(this.is_empty(a))
            return last_item;
        
        return a.join(separator) + last_item_seperator + last_item;
    },
    set_cookie(c_name, value, expiredays, expirehours) {
        let exdate = new Date();

        if(expiredays > 0)
    	    exdate.setDate(exdate.getDate()+expiredays);
    
        if(expirehours > 0)
            exdate.setHours(exdate.getHours()+expirehours);
    
    	document.cookie = c_name + "=" + escape(value) + (expiredays === null ? "" : "; expires=" + exdate.toGMTString()) + "; domain=." + window.location.host.split(':')[0].replace('www.', '') + "; path=/";
    },
    get_cookie(c_name) {
        if(document.cookie.length <= 0)
            return false;

		let c_start = document.cookie.indexOf(c_name + "=");
		
		if (c_start != -1) {
			c_start	    = c_start + c_name.length+1; 
			let c_end	= document.cookie.indexOf(";", c_start);
			
			if(c_end == -1)
				c_end = document.cookie.length;

			return unescape(document.cookie.substring(c_start, c_end));
		}
    },
    ksort(collection) {
        let response    = {};
        let entries     = _.sortBy(_.toPairs(collection), [0]);
        
        for(let i in entries)
            response[entries[i][0]] = entries[i][1];
        
        return response;
    },
    encapsulate(expression, string, react_element) {
        let match = string.match(expression);
        
        if(!match)
            return string;
        
        return <React.Fragment>{string.substring(0, match.index)}{React.createElement(...react_element, match[0])}{string.substring(match.index + match[0].length)}</React.Fragment>;
    },
    hexToRgb(hex, alpha) {
        hex             = hex.toString();
        let start_index = hex.startsWith('#') ? 1 : 0;
        let rgb         = parseInt(hex.substr(start_index, 2), 16) + ',' + parseInt(hex.substr(start_index + 2, 2), 16) + ',' + parseInt(hex.substr(start_index + 4, 2), 16);
        
        if(!_.is_empty(alpha))
            return 'rgba(' + rgb + ',' + alpha + ')';
        
        return 'rgb(' + rgb + ')';
    },
    wait(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    },
    calculateAge(date_of_birth, date_epoch) {
        if(!date_epoch)
            date_epoch = Date.now();
        
        var ageDifMs    = date_epoch - new Date(this.get_date_format(date_of_birth, true)).getTime();
        var ageDate     = new Date(ageDifMs);

        return Math.abs(ageDate.getUTCFullYear() - 1970);
    },
    googleMapsMetersToPixels(meters, zoom) {
        return meters * ((256 * Math.pow(2, zoom)) / 40075000);
    }
});

export default _;